module.exports = __webpack_public_path__ + "img/app-store.8ae9bbd2.svg";